export const Download = ({ className }) => {
  return (
    <div className='icon-button'>
      <div className='overlap-group'>
        <svg
          className={`functional-icons ${className}`}
          fill='none'
          height='18'
          viewBox='0 0 18 18'
          width='18'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            className='path'
            clipRule='evenodd'
            d='M9.84663 1.6875L9.84663 15.3532L8.17014 15.3532L8.17014 1.6875L9.84663 1.6875Z'
            fill='#F4F2F2'
            fillRule='evenodd'
          />
          <path
            className='path'
            clipRule='evenodd'
            d='M9.11978 14.6258L13.4395 10.4004L14.625 11.5599L10.3052 15.7854C9.5844 16.4905 8.41978 16.4846 7.69898 15.7895L7.69474 15.7854L3.375 11.5599L4.56046 10.4004L8.87729 14.6229C8.95003 14.6918 9.05862 14.6856 9.11978 14.6258Z'
            fill='#F4F2F2'
            fillRule='evenodd'
          />
          <path
            className='path'
            d='M8.12776 2.8125L9.81526 2.8125L9.81526 1.6875L8.12776 1.125L8.12776 2.8125Z'
            fill='#F4F2F2'
          />
        </svg>{' '}
        <div className='rectangle' />
      </div>
    </div>
  );
};
